import { render, staticRenderFns } from "./NewPolylinePropertyEditor.vue?vue&type=template&id=eb45f798&scoped=true&"
import script from "./NewPolylinePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewPolylinePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb45f798",
  null
  
)

export default component.exports